import { Outlet, useLocation } from "react-router-dom";
import TabBarList from "../components/navigation/TabBarList";
import { useCurrentUser } from "../utils/CurrentUserContext";
import { CompanyType } from "../__generated__/graphql";
import HomeGraph from "../components/widgets/HomeGraph";

const Home = () => {
  const {user} = useCurrentUser()

  const tabs = [
    { name: "Recent", href: "/" },
    ...([CompanyType.Advertiser, CompanyType.Publisher].includes(user?.company?.type) ?
      [{ name: "Action needed", href: '/waiting'}] : []
    ),
    { name: "Ready", href: "/ready" },
    { name: "Active", href: "/active" },
  ];

  return (
    <div className="lg:grid lg:grid-cols-7 lg:gap-8">
      <div className="lg:col-span-9 xl:col-span-7">
        <HomeGraph />
        <TabBarList tabs={tabs} location={useLocation()} />

        <div className="mt-1">
          <Outlet context={{}} />
        </div>
      </div>
    </div>
  );
};
export default Home;
